export default __webpack_public_path__ + "static/media/kartu-6.8a03c3dc.jpg";